export default "__VITE_ASSET__jUQjh$P___"